import React from 'react';

const ALIGN_X = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
    spread: 'space-between',
};

const ALIGN_Y = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
    stretch: 'stretch',
};

export const Inline = React.forwardRef(function Inline(
    {
        children,
        style = {},
        gap = 0,
        stretch = false,
        noWrap = false,
        alignX = 'left',
        alignY = 'top',
        ...rest
    },
    ref,
) {
    return (
        <div
            ref={ref}
            style={{
                display: 'flex',
                gap: `${gap}px`,
                flex: stretch ? 1 : undefined,
                flexWrap: noWrap ? 'nowrap' : 'wrap',
                justifyContent: ALIGN_X[alignX],
                alignItems: ALIGN_Y[alignY],
                ...style,
            }}
            {...rest}
        >
            {children}
        </div>
    );
});
